<template>
    <v-select :items="customerTypeItems" :value="value" @input="syncValue" label="Kundetype" hide-details/>
</template>

<script>
import {getCustomerTypeItems} from "@/helpers";

export default {
    props: {
        value: {
            type: Number
        },
    },
    methods: {
        syncValue(value) {
            this.$emit('input', value);
        }
    },
    computed: {
        customerTypeItems() {
            return [
                {value: null, text: 'Alle'},
                ...getCustomerTypeItems()
            ]
        },

    }
}
</script>

<style scoped>

</style>
